import React from "react";
// Material imports
import PlaneFly from "@limitless/icons/PlaneFly";

// Limitless imports
import Badge from "@limitless/modern/feedback/badge/Badge";
import { useExpertOnboardingMetrics } from "@limitless/expert";
import { useTranslation } from "@limitless/common/hooks";

const OnboardingBadgeIcon = () => {
    const { t } = useTranslation();
    const { getNumOfUnreadNotifications } = useExpertOnboardingMetrics(t);

    const count = getNumOfUnreadNotifications() || 0;

    return (
        <Badge
            content={<PlaneFly />}
            count={count}
            name="onboarding"
            sx={{ "& .MuiBadge-badge": { left: 35, top: 27 } }}
        />
    );
};

export default OnboardingBadgeIcon;
